export default __webpack_public_path__ + "static/media/orange_bubble_bg.720b4a05.png";